// Copyright (c) 2016 Deere & Company

import './maintenance-interval.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import Interval from '@deere/cps-it.warranty-model-factory/lib/interval';
import LabeledString from '../../../shared/components/labeled-string';
import {buildDate} from '../../../shared/services/build-date';

const MaintenanceInterval = ({maintenanceInterval, uom}) =>
    <section className='maintenance-interval'>
        <div className='interval-header'>
            <span className='maintenance-plan-item-type'>
                <FormattedMessage id={maintenanceInterval.type}/>
            </span>
            <span className='maintenance-plan-item-status'>
                <FormattedMessage id={maintenanceInterval.status}/>
            </span>
        </div>
        <div className='interval-details'>

            <LabeledString
                className='service-interval'
                data={String(maintenanceInterval.number)}
                label='SERVICE_INTERVAL'
            />
            <LabeledString
                className='begin-date'
                data={buildDate(maintenanceInterval.beginDate)}
                label='BEGIN_DATE'
            />
            <LabeledString
                className='end-date'
                data={buildDate(maintenanceInterval.endDate)}
                label='END_DATE'
            />
            <LabeledString
                className='completed-date'
                data={buildDate(maintenanceInterval.completedDate)}
                label='COMPLETED_DATE'
            />
            <LabeledString
                className='hours-limit'
                data={String(maintenanceInterval.hoursLimit)}
                label={`${uom}_LIMIT`}
            />
            <LabeledString
                className='actual-hours'
                data={String(maintenanceInterval.actualHours)}
                label={`ACTUAL_${uom}`}
            />

        </div>
    </section>;

MaintenanceInterval.displayName = 'MaintenanceInterval';
MaintenanceInterval.propTypes = {
    maintenanceInterval: PropTypes.instanceOf(Interval).isRequired,
    uom: PropTypes.string.isRequired
};

export default MaintenanceInterval;



// WEBPACK FOOTER //
// ./src/product/details/components/maintenance-interval.js